import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./loginSlice";
import flagReducer from "./flagSlice";
import registerReducer from "./registerSlice";
import passwordSlice from "./passwordSlice";
import dashboardSlice from "./dashboardSlice";
import sentSlice from "./sentSlice";
import auditTrailSlice from "./auditTrailSlice";
import pdfSlice from "./pdfSlice";
import profileSlice from "./profileSlice";
import reportsSlice from "./reportsSlice";
import receivedSlice from "./receivedSlice";
import receivedPDFSlice from "./receivedPDFSlice";
import creditSlice from "./creditSlice";
import superAdminSlice from "./superAdminSlice";
import addCreditSlice from "./addCreditSlice";
import addUserSlice from "./addUserSlice";
import superAdminCreditSlice from "./superAdminCreditSlice";
import postpaidBillPaymentSlice from "./postpaidBillPaymentSlice";
import superAdminDashboardSlice from "./superAdminDashboardSlice";
import changeAccountTypeSlice from "./changeAccountTypeSlice";
import allCompanyDetailsSlice from "./allCompanyDetailsSlice";
import pdfGenrateTokenSlice from "./pdfGenrateTokenSlice";
import genrateEsignTokenWithDocumentIDSlice from "./genrateEsignTokenWithDocumentIDSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    flag: flagReducer,
    register: registerReducer,
    password: passwordSlice,
    dashboard: dashboardSlice,
    sent: sentSlice,
    audit: auditTrailSlice,
    pdf: pdfSlice,
    profile: profileSlice,
    report: reportsSlice,
    received: receivedSlice,
    receivedPDF: receivedPDFSlice,
    credit: creditSlice,
    superAdmin: superAdminSlice,
    addCredit: addCreditSlice,
    addUser: addUserSlice,
    superAdminCredit: superAdminCreditSlice,
    postpaidBillPayment: postpaidBillPaymentSlice,
    superAdminDashboard: superAdminDashboardSlice,
    changeAccountType: changeAccountTypeSlice,
    allCompanyDetails: allCompanyDetailsSlice,
    pdfGenrateToken: pdfGenrateTokenSlice,
    genrateEsignTokenWithDocumentID: genrateEsignTokenWithDocumentIDSlice,
  },
});
export default store;
